import { render } from "./FundingManagement.vue?vue&type=template&id=4af8084a"
import script from "./FundingManagement.vue?vue&type=script&lang=js"
export * from "./FundingManagement.vue?vue&type=script&lang=js"

import "./FundingManagement.vue?vue&type=style&index=0&id=4af8084a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__